module.exports = __webpack_public_path__ + "img/album21_13.92377c55.jpg";